<template>
  <div>
    <tool-bar :title="title" subTitle=""></tool-bar>
    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <date-picker-dialog
      :show-date-picker="showDatePicker"
      :default-selected-date="defaultSelectedDate"
      select-date-title="Select Date of Birth"
      @closeClicked="showDatePicker=false"
      @dateSelected="onDobSelected"
    ></date-picker-dialog>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <stage-comment-item></stage-comment-item>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="fetchInitialData"
    ></refresh-item>

    <div class="margin_top_20" v-show="showUI">
      <div class="margin-left-10 margin-right-10">
        <weex-text class="input_label">Applying Service for</weex-text>
        <div v-for="serviceConsumer in serviceConsumers"
             @click="onServiceConsumerSelected(serviceConsumer)"
             :key="serviceConsumer.value"
             class="margin-top-10">
          <div class="item-row-alignment-center">
            <weex-image
              class="ezcred-radio-image"
              :src="radioButtonLink(serviceConsumer)"
            ></weex-image>
            <weex-text class="ezcred-radio-text">{{serviceConsumer.title}}</weex-text>
          </div>
        </div>
      </div>


      <div v-show="showInputFields" class="padding-top-10">

        <div class="input_container" v-if="isFieldNeeded('name')">
          <weex-text class="input_label">{{getFieldLabel('name')}}</weex-text>
          <input
            class="input_with_border_bottom"
            :value="getFieldValue('name')"
            @input="onNameEntered($event.target.value)"
            return-key-type="next">
          <field-error-item
            :show-error="showFieldError('name')"
            :error-msg="getErrorMsg('name')"
          ></field-error-item>
        </div>

        <div class="input_container" v-if="isFieldNeeded('date_of_birth')">
          <weex-text class="input_label">{{getFieldLabel('date_of_birth')}}</weex-text>
          <input
            ref="dob"
            @focus="showDOBPickerDialog"
            class="input_with_border_bottom"
            :value="getFieldValue('date_of_birth')"
            return-key-type="next">
          <field-error-item
            :show-error="showFieldError('date_of_birth')"
            :error-msg="getErrorMsg('date_of_birth')"
          ></field-error-item>
        </div>


        <div class="input_container" v-if="isFieldNeeded('gender')">
          <weex-text class="input_label">{{getFieldLabel('gender')}}</weex-text>
          <div class="padding-bottom-10">
            <div v-for="gender in genders"
                 @click="onGenderSelected(gender.value)"
                 :key="gender.value"
                 class="margin-top-10">
              <div class="item-row-alignment-center">
                <weex-image
                  class="ezcred-radio-image"
                  :src="radioButtonLink(gender)"
                ></weex-image>
                <weex-text class="ezcred-radio-text">{{gender.title}}</weex-text>
              </div>
            </div>
          </div>

          <field-error-item
            :show-error="showFieldError('gender')"
            :error-msg="getErrorMsg('gender')"
          ></field-error-item>
        </div>

        <div class="dropdown_container" v-show="isFieldNeeded('relation_with_applicant')">
          <wxc-dropdown
            :title="getFieldLabel('relation_with_applicant')"
            default-item="Select"
            :config="dropdownConfig"
            :list="relations"
            :select-item="getFieldValue('relation_with_applicant')"
            @onItemSelected="onRelationWithApplicantSelected"
          ></wxc-dropdown>
          <field-error-item
            :show-error="showFieldError('relation_with_applicant')"
            :error-msg="getErrorMsg('relation_with_applicant')"
          ></field-error-item>
        </div>

        <div class="input_container" v-if="isFieldNeeded('board')">
          <weex-text class="input_label">{{getFieldLabel('board')}}</weex-text>
          <input
            class="input_with_border_bottom"
            :value="getFieldValue('board')"
            @input="onInputEntered('board', $event.target.value)"
            return-key-type="next">
          <field-error-item
            :show-error="showFieldError('board')"
            :error-msg="getErrorMsg('board')"
          ></field-error-item>
        </div>

        <div class="input_container" v-if="isFieldNeeded('class')">
          <weex-text class="input_label">{{getFieldLabel('class')}}</weex-text>
          <input
            class="input_with_border_bottom"
            :value="getFieldValue('class')"
            @input="onInputEntered('class', $event.target.value)"
            return-key-type="next">
          <field-error-item
            :show-error="showFieldError('class')"
            :error-msg="getErrorMsg('class')"
          ></field-error-item>
        </div>

        <div class="input_container" v-if="isFieldNeeded('course')">
          <weex-text class="input_label">{{getFieldLabel('course')}}</weex-text>
          <input
            class="input_with_border_bottom"
            :value="getFieldValue('course')"
            @input="onInputEntered('course', $event.target.value)"
            return-key-type="next">
          <field-error-item
            :show-error="showFieldError('course')"
            :error-msg="getErrorMsg('course')"
          ></field-error-item>
        </div>

        <div class="input_container" v-if="isFieldNeeded('application_no')">
          <weex-text class="input_label">{{getFieldLabel('application_no')}}</weex-text>
          <input
            class="input_with_border_bottom"
            :value="getFieldValue('application_no')"
            @input="onInputEntered('application_no', $event.target.value)"
            return-key-type="next">
          <field-error-item
            :show-error="showFieldError('application_no')"
            :error-msg="getErrorMsg('application_no')"
          ></field-error-item>
        </div>
      </div>

      <wxc-button
        text="Next"
        class="button_horizontal_center margin-top-60 margin-bottom-20"
        type="blue"
        @wxcButtonClicked="onSubmit"
      ></wxc-button>
    </div>
  </div>
</template>

<script>
import ToolBar from "../layout/ToolBar";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import FieldErrorItem from "../layout/FieldErrorItem";
import StageCommentItem from "../layout/StageCommentItem";
import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import RefreshItem from "../layout/RefreshItem";
import Loading from "../layout/Loading";
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import WxcDropdown from "../../../weex-ui/packages/wxc-dropdown/index";
import AlertService from "../core/alert/AlertService";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import DataSource from "../../data/DataSource";
import EzUtils from "../../utils/EzUtils";
import LoanTasksActivityNavigator from "../../utils/LoanTasksActivityNavigator";
import DynamicFieldUtils from "../../utils/DynamicFieldUtils";
import { DataTables } from "../../utils/DataTables";
import { Activities } from "../../utils/ActivityNavigator";
import { DefaultResourceConfig, ImageResourcesUtil } from "../../utils/ImageResourcesUtil";
import DataTableUtils from "../../utils/DataTableUtils";
import DateUtils, { DateFormats } from "../../utils/DateUtils";
import DatePickerDialog from "../dialogs/DatePickerDialog";

const NON_EMPTY_ALPHABET_STRING_PATTERN = "^[a-zA-Z\\s]+$";
const SELF = "Self";
const OTHER = "Other";
const SELECT_OPTION_TO_CONTINUE = "Please select an option to continue";

const MALE = "Male";
const FEMALE = "Female";
const OTHER_GENDER = "Other";

const INVALID_DATE = "Invalid date";

const ALL_FIELDS_DATA = {
  name: {
    label: "Name",
    validation: NON_EMPTY_ALPHABET_STRING_PATTERN,
    fieldType: "EDIT_FIELD",
    errorMsg: "Please enter valid Name",
    optional: false
  },
  date_of_birth: {
    label: "Date of Birth",
    validation: "",
    fieldType: "EDIT_FIELD",
    errorMsg: "Please enter Date of Birth",
    optional: false
  },
  gender: {
    label: "Gender",
    fieldType: "RADIO",
    errorMsg: "Please select Gender",
    optional: false
  },
  board: {
    label: "Board",
    validation: "",
    fieldType: "EDIT_FIELD",
    errorMsg: "Please enter Board",
    optional: false
  },
  relation_with_applicant: {
    label: "Relation with Applicant",
    validation: "",
    fieldType: "DROPDOWN",
    errorMsg: "Please select Relation with Applicant",
    optional: false
  },
  class: {
    label: "Class",
    validation: "",
    fieldType: "EDIT_FIELD",
    errorMsg: "Please enter Class",
    optional: false
  },
  course: {
    label: "Product Name/Course",
    validation: "",
    fieldType: "EDIT_FIELD",
    errorMsg: "Please enter Product Name/Course",
    optional: false
  },
  application_no: {
    label: "Application Number",
    validation: "",
    fieldType: "EDIT_FIELD",
    errorMsg: "Please enter Application Number",
    optional: false
  }
};

export default {
  name: "StudentDetails",
  components: {
    RefreshItem,
    ActivityRedirectItem,
    ToolBar,
    WxcButton,
    WxcDropdown,
    Loading,
    ErrorAlertItem,
    FieldErrorItem,
    StageCommentItem,
    DatePickerDialog
  },
  data: () => ({
    title: "Student Details",
    loading: false,
    networkError: {},
    errorAlertEvent: false,
    showUI: false,
    dynamicFields: null,
    serviceConsumers: [
      { title: SELF, value: SELF, checked: false },
      { title: OTHER, value: OTHER, checked: false }
    ],
    genders: [
      { title: MALE, value: MALE, checked: false },
      { title: FEMALE, value: FEMALE, checked: false },
      { title: OTHER_GENDER, value: OTHER_GENDER, checked: false }
    ],
    relations: [],
    selectedServiceConsumer: null,
    studentDetails: {
      name: null,
      date_of_birth: null,
      gender: null,
      board: "",
      relation_with_applicant: null,
      class: null,
      course: null,
      application_no: null
    },
    invalidFields: [],
    showRefreshItem: false,
    showDatePicker: false,
    defaultSelectedDate: "1995-01-01"
  }),

  methods: {
    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    showToast(message) {
      AlertService.showToast(message);
    },

    isFieldNeeded(key) {
      return this.dynamicFields == null || this.dynamicFields[key] != null;
    },

    getFieldLabel(key) {
      if (this.dynamicFields && this.dynamicFields[key] && this.dynamicFields[key]["label"]) {
        return this.dynamicFields[key]["label"];
      }
      return ALL_FIELDS_DATA[key]["label"];
    },

    getFieldValue(key) {
      return this.studentDetails ? this.studentDetails[key] : "";
    },

    showFieldError(fieldKey) {
      return this.invalidFields && this.invalidFields.includes(fieldKey);
    },

    getErrorMsg(fieldKey) {
      return ALL_FIELDS_DATA[fieldKey]["errorMsg"];
    },

    onServiceConsumerSelected(e) {
      this.serviceConsumers.forEach(serviceConsumer => {
        serviceConsumer.checked = false;
      });
      e.checked = true;
      this.selectedServiceConsumer = e.value;
    },

    onGenderSelected(gender) {
      this.genders.forEach(genderData => {
        genderData.checked = false;
        if (gender && gender === genderData.value) {
          genderData.checked = true;
          this.onInputEntered("gender", gender);
        }
      });
    },

    onRelationWithApplicantSelected(e) {
      this.onInputEntered("relation_with_applicant", e.value);
    },

    onNameEntered(name) {
      this.onInputEntered("name", EzUtils.convertToUpperCamelCase(name));
    },

    onInputEntered(key, value) {
      this.studentDetails[key] = value;
      this.removeFromInvalidFieldsIfValid(key);
    },

    showDOBPickerDialog() {
      this.showDatePicker = true;
      this.$refs.dob.blur();
    },

    onDobSelected(date) {
      this.showDatePicker = false;
      if (this.$refs && this.$refs.dob) {
        this.$refs.dob.blur();
      }
      this.dobSelectedWithDateFormat(date, DateFormats.YYYY_MM_DD);
    },

    dobSelectedWithDateFormat(date, dateFormat) {
      const formattedDOB = DateUtils.getFormatDateAsString(
        date,
        dateFormat,
        DateFormats.DD_MMMM_YYYY
      );
      const defaultSelectedDate = DateUtils.getFormatDateAsString(
        date,
        dateFormat,
        DateFormats.YYYY_MM_DD
      );
      if (formattedDOB
        && defaultSelectedDate
        && !EzUtils.areEqualString(INVALID_DATE, formattedDOB, true)
        && !EzUtils.areEqualString(INVALID_DATE, defaultSelectedDate, true)
      ) {
        this.defaultSelectedDate = defaultSelectedDate;
        this.onInputEntered("date_of_birth", formattedDOB);
      }
    },

    radioButtonLink(e) {
      return e.checked
        ? ImageResourcesUtil.getImageLink(ImageResourcesUtil.CHECKED_RADIO)
        : ImageResourcesUtil.getImageLink(ImageResourcesUtil.UNCHECKED_RADIO);
    },

    removeFromInvalidFieldsIfValid(key) {
      this.invalidFields = DynamicFieldUtils.removeFromInvalidFieldsIfValidValue(
        this.invalidFields,
        key,
        this.studentDetails[key],
        ALL_FIELDS_DATA,
        this.dynamicFields
      );
    },

    onSubmit() {
      if (this.checkForValidation()) {
        if (OTHER === this.selectedServiceConsumer) {
          this.saveStudentDetails();
        } else {
          this.completeCurrentTaskAndGetNextTask();
        }
      }
    },

    checkForValidation() {
      if (!this.selectedServiceConsumer) {
        this.showToast(SELECT_OPTION_TO_CONTINUE);
        return false;
      }

      if (OTHER === this.selectedServiceConsumer) {
        this.invalidFields = DynamicFieldUtils.validateDynamicFieldsForRequiredFields(
          this.studentDetails,
          ALL_FIELDS_DATA,
          this.dynamicFields
        );

        return !this.invalidFields || this.invalidFields.length === 0;
      }

      return true;
    },

    saveStudentDetails() {
      this.loading = true;
      DataSource.getDataTableInfo(DataTables.STUDENT_DETAILS, LoanScopeDataHolder.getLoanId())
        .then(studentDetailsRes => {
          if (studentDetailsRes.errorOccurred) {
            this.showError(studentDetailsRes.data)
          } else {
            const studentDetailsList = studentDetailsRes.data;
            if (EzUtils.isNotEmpty(studentDetailsList)) {
              DataSource.updateDataTableEntryInMultiRowDataTable(
                DataTables.STUDENT_DETAILS,
                LoanScopeDataHolder.getLoanId(),
                studentDetailsList[studentDetailsList.length - 1].id,
                this.studentDetails
              )
                .then(res => {
                  if (res.errorOccurred) {
                    this.showError(res.data)
                  } else {
                    this.completeCurrentTaskAndGetNextTask();
                  }
                })
            } else {
              DataSource.addDataTableEntry(
                DataTables.STUDENT_DETAILS,
                LoanScopeDataHolder.getLoanId(),
                this.studentDetails
              )
                .then(res => {
                  this.loading = false;
                  if (res.errorOccurred) {
                    this.showError(res.data);
                  } else {
                    this.completeCurrentTaskAndGetNextTask();
                  }
                })
            }
          }
        })
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        });
    },

    fetchInitialData() {
      this.showRefreshItem = false;
      this.loading = true;
      DataSource.getDataTableInfo(DataTables.STUDENT_DETAILS, LoanScopeDataHolder.getLoanId())
        .then(dataTableRes => {
          this.loading = false;
          if (dataTableRes.errorOccurred) {
            this.showError(dataTableRes.data);
            this.showRefreshItem = true;
          } else {
            this.showUI = true;
            const studentDetailsList = dataTableRes.data;
            if (studentDetailsList && studentDetailsList.length > 0) {
              const studentDetailsFromServer = studentDetailsList[studentDetailsList.length - 1];
              this.onInputEntered("name", studentDetailsFromServer.name);
              this.onInputEntered("date_of_birth", studentDetailsFromServer.date_of_birth);
              this.onInputEntered("board", studentDetailsFromServer.board);
              this.onInputEntered("class", studentDetailsFromServer.class);
              this.onInputEntered("course", studentDetailsFromServer.course);
              this.onInputEntered("application_no", studentDetailsFromServer.application_no);
              this.onInputEntered(
                "relation_with_applicant",
                studentDetailsFromServer.relation_with_applicant
              );
              this.onDobSelected(studentDetailsFromServer.date_of_birth, DateFormats.YYYY_MM_DD);
              this.onGenderSelected(studentDetailsFromServer.gender);
            }
          }
        })
    }
  },

  created: function () {
    this.dynamicFields = DynamicFieldUtils.getRequiredDynamicFieldsData();
    this.relations = [
      { title: "Father", value: "FATHER" },
      { title: "Mother", value: "MOTHER" },
      { title: "Husband", value: "HUSBAND" },
      { title: "Wife", value: "WIFE" },
      { title: "Brother", value: "BROTHER" },
      { title: "Sister", value: "SISTER" },
      { title: "Grand Father", value: "GRAND_FATHER" },
      { title: "Grand Mother", value: "GRAND_MOTHER" },
      { title: "Legal Guardian", value: "LEGAL_GUARDIAN" },
      { title: "Friend", value: "FRIEND" },
      { title: "Relative", value: "RELATIVE" },
      { title: "Other", value: "OTHER" }
    ];
    this.fetchInitialData();
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.STUDENT_DETAILS];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },

    showInputFields() {
      return OTHER === this.selectedServiceConsumer;
    },

    dropdownConfig() {
      return DefaultResourceConfig.DROP_DOWN;
    }
  }
}
</script>

<style scoped src="../../assets/style/base.css"></style>
